import styled from 'styled-components';

import {
  EditorSection,
  ErrorContainer,
  OptionTable,
  StyledOptionsSection,
} from 'src/presentation/components/pages/shared/EditorSectionLayout';

const EntryPointsExceptions = styled(EditorSection)`
  ${StyledOptionsSection} {
    border-radius: 0;

    &:first-child td:first-child {
      border-top-left-radius: 0;
    }
    &:first-child td:last-child {
      border-top-right-radius: 0;
    }

    ${OptionTable} > tbody > tr > td:first-child {
      padding-left: ${p => p.theme.spacing.stackLarge};
    }
  }

  ${ErrorContainer} {
    display: none;
  }
`;

export default EntryPointsExceptions;
